import React from "react";

const SiteAnalysis = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("siteAnalysis", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Site Analysis</h3>
        <div className="form-group">
          <label className="required">Connectivity</label>
          <input
            type="text"
            name="connectivity"
            value={pfrFormData.siteAnalysis.connectivity}
            onChange={handleInputChange}
            placeholder="Enter Connectivity"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Land Form, Land use pattern and land ownership
          </label>
          <input
            type="text"
            name="landForm"
            value={pfrFormData.siteAnalysis.landForm}
            onChange={handleInputChange}
            placeholder="Enter Land Form"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Type of Land</label>
          <input
            type="text"
            name="typeOfLand"
            value={pfrFormData.siteAnalysis.typeOfLand}
            onChange={handleInputChange}
            placeholder="Enter Type of Land"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Topography</label>
          <textarea
            type="text"
            name="topography"
            value={pfrFormData.siteAnalysis.topography}
            onChange={handleInputChange}
            placeholder="Enter Topography"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Existing Land use pattern of the study area
          </label>
          <textarea
            type="text"
            name="existingLandUsePattern"
            value={pfrFormData.siteAnalysis.existingLandUsePattern}
            onChange={handleInputChange}
            placeholder="Enter Existing Land use pattern of the study area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Existing Infrastructure</label>
          <textarea
            type="text"
            name="existingInfrastructure"
            value={pfrFormData.siteAnalysis.existingInfrastructure}
            onChange={handleInputChange}
            placeholder="Enter Existing Infrastructure"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Soil Classification</label>
          <textarea
            type="text"
            name="soilClassification"
            value={pfrFormData.siteAnalysis.soilClassification}
            onChange={handleInputChange}
            placeholder="Enter Soil Classification"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Rainfall and Climate</label>
          <textarea
            type="text"
            name="rainfallAndClimate"
            value={pfrFormData.siteAnalysis.rainfallAndClimate}
            onChange={handleInputChange}
            placeholder="Enter Rainfall and Climate"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Social Infrastructure available</label>
          <textarea
            type="text"
            name="socialInfrastructureAvailable"
            value={pfrFormData.siteAnalysis.socialInfrastructureAvailable}
            onChange={handleInputChange}
            placeholder="Enter Social Infrastructure available"
            required
          />
        </div>
      </div>
    </>
  );
};

export default SiteAnalysis;
